module.exports = __webpack_public_path__ + "img/日本站.b0b95ff8.png";